import { createContext, useContext, type ReactNode } from 'react';
import { assert } from '~/lib/assert';
import type { DesignFilters, DesignFiltersState } from './';

export type DesignFiltersContextType = DesignFiltersState & {
  clearFilters: () => void;
  reinitialize: (params: string) => void;
  setFilter: (
    field: {
      [K in keyof DesignFilters]: { field: K; items: DesignFilters[K]['items']; open?: boolean };
    }[keyof DesignFilters],
  ) => void;
  toggleFilter: (field: keyof DesignFilters) => void;
  togglePanel: () => void;
};

export const DesignFiltersContext = createContext<DesignFiltersContextType | undefined>(undefined);

export const useDesignFilters = () => {
  const context = useContext(DesignFiltersContext);
  assert(context !== undefined, 'useDesignFilters must be used with a DesignFiltersProvider');
  return context;
};

export interface DesignFiltersProviderProps extends DesignFiltersContextType {
  children: ReactNode;
}

export const DesignFiltersProvider = ({ children, ...rest }: DesignFiltersProviderProps) => (
  <DesignFiltersContext.Provider value={{ ...rest }}>{children}</DesignFiltersContext.Provider>
);
